<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  {...$$props}
>
  <path
    d="M7.29289 4.70711C7.68342 4.31658 8.31658 4.31658 8.70711 4.70711L11.2929 7.29289C11.6834 7.68342 11.6834 8.31658 11.2929 8.70711L8.70711 11.2929C8.31658 11.6834 7.68342 11.6834 7.29289 11.2929L4.70711 8.70711C4.31658 8.31658 4.31658 7.68342 4.70711 7.29289L7.29289 4.70711Z"
    fill="currentColor"
  />
</svg>
